module.exports = "/_next/static/images/loading_08-9e3d9c2668d6b60660018fba94cd3079.png";